import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-loader',
  templateUrl: './full-loader.component.html',
  styleUrls: ['./full-loader.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullLoaderComponent implements OnInit {

  constructor() {}

  ngOnInit() {}


}
